"use strict";exports.__esModule = true;exports.default = void 0;var scrollKeyPreventer = _interopRequireWildcard(require("makeup-prevent-scroll-keys"));
var _makeupRovingTabindex = require("makeup-roving-tabindex");
var _makeupTypeahead = _interopRequireDefault(require("makeup-typeahead"));
var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));
var _menuUtils = _interopRequireDefault(require("../../common/menu-utils"));function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}

var TYPEAHEAD_TIMEOUT_LENGTH = 1300;var _default =

Object.assign({}, _menuUtils.default, {
  toggleItemChecked(index, originalEvent, itemEl) {
    // This needs to be at start since toggleChecked swaps the checkedIndex
    // and then the right events will not fire correctly
    var shouldEmitRadio = this.isRadio() && index !== this.state.checkedIndex;
    this.toggleChecked(index);

    if (shouldEmitRadio) {
      this.emitComponentEvent({
        index,
        eventType: 'change',
        el: itemEl,
        originalEvent });

    } else if (this.type !== 'radio') {
      this.emitComponentEvent({
        index,
        eventType: !this.type ? 'select' : 'change',
        el: itemEl,
        originalEvent });

    }

    if (this.rovingTabindex) {
      this.tabindexPosition = this.rovingTabindex.filteredItems.findIndex(
      (el) => el.tabIndex === 0);

    }
  },

  handleItemClick(index, originalEvent, itemEl) {
    this.toggleItemChecked(index, originalEvent, itemEl);
  },

  handleItemKeydown(index, originalEvent, itemEl) {
    eventUtils.handleEscapeKeydown(originalEvent, () => {
      this.emitComponentEvent({ eventType: 'keydown', originalEvent, index });
    });

    eventUtils.handleActionKeydown(originalEvent, () =>
    this.toggleItemChecked(index, originalEvent, itemEl));

  },

  handleItemKeypress(_ref) {var { key } = _ref;
    var itemIndex = this.getTypeaheadIndex(
    this.getEl('menu').children,
    key,
    this.input.typeaheadTimeoutLength || TYPEAHEAD_TIMEOUT_LENGTH);


    if (itemIndex !== -1) {
      this.tabindexPosition = this.rovingTabindex.index = itemIndex;
    }
  },

  emitComponentEvent(_ref2) {var { eventType, el, originalEvent, index } = _ref2;
    var checkedIndexes = this.getCheckedIndexes();
    var isCheckbox = this.type === 'checkbox';

    var eventObj = {
      el,
      originalEvent };


    if (isCheckbox && checkedIndexes.length > 1) {
      Object.assign(eventObj, {
        index,
        indexes: this.getCheckedIndexes(), // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else if (isCheckbox || this.isRadio()) {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: this.getCheckedIndexes(), // DEPRECATED in v5 (keep but change from indexes to values)
        checkedValues: this.getCheckedValues() // DEPRECATED in v5
      });
    } else {
      Object.assign(eventObj, {
        index, // DEPRECATED in v5
        checked: [index] // DEPRECATED in v5 (keep but change from indexes to values)
      });
    }

    this.emit("" + eventType, eventObj);
  },

  onInput(input) {
    this.state = this.getInputState(input);
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  onMount() {
    this.tabindexPosition = 0;
    this._setupMakeup();
  },

  onUpdate() {
    this._setupMakeup();
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupMakeup() {
    this.contentEl = this.getEl('menu');

    this.rovingTabindex = (0, _makeupRovingTabindex.createLinear)(this.contentEl, 'div', {
      index: this.tabindexPosition,
      autoReset: null });


    scrollKeyPreventer.add(this.contentEl);

    var { getIndex: getTypeaheadIndex, destroy: destroyTypeahead } = (0, _makeupTypeahead.default)();
    this.getTypeaheadIndex = getTypeaheadIndex;
    this.destroyTypeahead = destroyTypeahead;
  },

  _cleanupMakeup() {
    if (this.rovingTabindex) {
      this.rovingTabindex.destroy();
      scrollKeyPreventer.remove(this.contentEl);
    }
    if (this.destroyTypeahead) {
      this.destroyTypeahead();
    }
  } });exports.default = _default;module.exports = exports.default;